import { TechInsightsClient as TechInsightsClient$1 } from '@backstage-community/plugin-tech-insights-common/client';
import { jsonRulesEngineCheckResultRenderer } from '../components/CheckResultRenderer.esm.js';

class TechInsightsClient extends TechInsightsClient$1 {
  renderers;
  customGetEntityLinks;
  constructor(options) {
    super(options);
    this.renderers = options.renderers;
    this.customGetEntityLinks = options.getEntityLinks ?? (() => []);
  }
  getCheckResultRenderers(types) {
    const renderers = this.renderers ?? [jsonRulesEngineCheckResultRenderer];
    return renderers.filter((d) => types.includes(d.type));
  }
  isCheckResultFailed(check) {
    const checkResultRenderers = this.getCheckResultRenderers([
      check.check.type
    ]);
    if (checkResultRenderers[0] && checkResultRenderers[0].isFailed) {
      return checkResultRenderers[0].isFailed(check);
    }
    return true;
  }
  getLinksForEntity(result, entity, options = {}) {
    const links = this.customGetEntityLinks(result, entity);
    if (options.includeStaticLinks) {
      links.push(...result.check.links ?? []);
    }
    return links;
  }
}

export { TechInsightsClient };
//# sourceMappingURL=TechInsightsClient.esm.js.map
